"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useCreateSelectOptions = void 0;
/** @jsx jsx */
var react_1 = require("@emotion/react");
var react_2 = require("react");
var react_select_1 = __importDefault(require("react-select"));
var icons_1 = require("../../../icons");
var variables_1 = require("../../../style/variables");
var Loading_1 = __importDefault(require("../../Loading"));
var styles_1 = require("./styles");
var utils_1 = require("./utils");
var useCreateSelectOptions_1 = require("./useCreateSelectOptions");
Object.defineProperty(exports, "useCreateSelectOptions", { enumerable: true, get: function () { return __importDefault(useCreateSelectOptions_1).default; } });
function Select(_a) {
    var placeholder = _a.placeholder, options = _a.options, disabled = _a.disabled, hideMultiValueRemove = _a.hideMultiValueRemove, showDot = _a.showDot, showUserIcon = _a.showUserIcon, multi = _a.multi, value = _a.value, onChange = _a.onChange, loading = _a.loading, hideSelectedOptions = _a.hideSelectedOptions, clearable = _a.clearable, searchable = _a.searchable, readOnly = _a.readOnly, onKeyDown = _a.onKeyDown, _b = _a.menuPlacement, menuPlacement = _b === void 0 ? 'auto' : _b, _c = _a.dropdownIcon, DropdownIcon = _c === void 0 ? icons_1.ChevronDown : _c, _d = _a.clearIcon, ClearIcon = _d === void 0 ? icons_1.XCircle : _d, components = _a.components, borderless = _a.borderless, _e = _a.justifyMenu, justifyMenu = _e === void 0 ? 'full' : _e, rest = __rest(_a, ["placeholder", "options", "disabled", "hideMultiValueRemove", "showDot", "showUserIcon", "multi", "value", "onChange", "loading", "hideSelectedOptions", "clearable", "searchable", "readOnly", "onKeyDown", "menuPlacement", "dropdownIcon", "clearIcon", "components", "borderless", "justifyMenu"]);
    var customStyles = react_2.useMemo(function () { return styles_1.createCustomStyles({ borderless: borderless, justifyMenu: justifyMenu }); }, [borderless, justifyMenu]);
    var innerComponents = react_2.useMemo(function () {
        var custom = utils_1.createCustomComponents({ readOnly: readOnly });
        if (hideMultiValueRemove) {
            custom.MultiValueRemove = function () { return null; };
        }
        custom.Option = function (props) { return (react_1.jsx(utils_1.CustomOption, __assign({}, props, { showDot: showDot, showUserIcon: showUserIcon }))); };
        custom.SingleValue = function (props) { return (react_1.jsx(utils_1.SingleValue, __assign({}, props, { showDot: showDot, showUserIcon: showUserIcon }))); };
        custom.MultiValue = function (props) { return (react_1.jsx(utils_1.MultiValue, __assign({}, props, { showDot: showDot, showUserIcon: showUserIcon }))); };
        custom.LoadingIndicator = function () { return react_1.jsx(Loading_1.default.Spinner, { size: 16 }); };
        custom.ClearIndicator = function (_a) {
            var clearValue = _a.clearValue, selectProps = _a.selectProps;
            return selectProps.isLoading || !ClearIcon ? null : (react_1.jsx(ClearIcon, { size: 20, css: { cursor: 'pointer' }, onClick: clearValue }));
        };
        custom.DropdownIndicator = function (_a) {
            var isMulti = _a.isMulti, hasValue = _a.hasValue, isDisabled = _a.isDisabled, selectProps = _a.selectProps;
            return ((isMulti && hasValue)
                || selectProps.isLoading
                || !DropdownIcon ||
                (selectProps.isClearable && hasValue)) ? null : (react_1.jsx(DropdownIcon, { size: 20, css: {
                    cursor: 'pointer',
                    color: "var(" + ((isDisabled || readOnly) ? variables_1.RootColor.Gray.LIGHT_2 : variables_1.RootColor.Gray.DEFAULT) + ")",
                } }));
        };
        return __assign(__assign({}, custom), components);
    }, [hideMultiValueRemove, showDot, showUserIcon, DropdownIcon, ClearIcon, readOnly, components]);
    return (react_1.jsx(react_select_1.default, __assign({}, rest, { styles: customStyles, value: value === undefined ? null : value, onChange: function (val) { return onChange === null || onChange === void 0 ? void 0 : onChange(val); }, options: options, components: innerComponents, hideSelectedOptions: hideSelectedOptions, getOptionValue: function (option) { return option.value; }, placeholder: placeholder, isMulti: multi, isDisabled: disabled, isLoading: loading, menuPortalTarget: document.body, isClearable: clearable, isSearchable: searchable, onKeyDown: onKeyDown, noOptionsMessage: options === undefined ? function () { return null; } : undefined, menuPlacement: menuPlacement, maxMenuHeight: 360 })));
}
exports.default = Select;
